export const DEFAULT_AVATAR_ALT = 'avatar';

export default {
  DEFAULT_AVATAR_ALT,
};
